import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "application",
  class: "application"
}
const _hoisted_2 = {
  key: 1,
  class: "router"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_router_view = _resolveComponent("router-view")
  const _component_ErrorModal = _resolveComponent("ErrorModal")
  const _component_PwaModal = _resolveComponent("PwaModal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($options.loading)
        ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Loading application"),
              _createElementVNode("br", null, null, -1 /* HOISTED */),
              _createTextVNode(" Please wait ")
            ])),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_view)
          ]))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("span", { id: "modals" }, null, -1 /* HOISTED */)),
    ($options.error)
      ? (_openBlock(), _createBlock(_component_ErrorModal, {
          key: 0,
          error: $options.error
        }, null, 8 /* PROPS */, ["error"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_PwaModal)
  ], 64 /* STABLE_FRAGMENT */))
}